"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chevron = exports.AccountHandle = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFeather = require("react-feather");

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AccountHandle = (0, _styledComponents["default"])(_slice.Text).attrs({
  color: 'orange',
  fontSize: 5,
  fontFamily: 'mrEaves',
  fontWeight: 'bold'
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  position: relative;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  position: relative;\n  text-transform: uppercase;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"])));
exports.AccountHandle = AccountHandle;
var Chevron = (0, _styledComponents["default"])(_reactFeather.ChevronDown)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  margin-left: 4px;\n"], ["\n  margin-left: 4px;\n"])));
exports.Chevron = Chevron;
var templateObject_1, templateObject_2;